import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const Block = styled(Vertical)`
  padding: var(--double-unit);
  flex-shrink: 0;
  overflow-x: hidden;
  border-left: 1px solid var(--c-nd-150-opaque);
  @media ${laptopAndAbove} {
    padding: var(--triple-unit);
  }
  &:not(:last-child) {
    border-bottom: 1px solid var(--c-nd-150-opaque);
  }
`;

export const PlayerDrawerTokenSkeleton = styled(Skeleton)`
  width: 100%;
  height: calc(18.5 * var(--unit));
  border-radius: var(--double-unit);
`;
